<script lang="ts" setup>
  import { cn } from "@/lib/utils"
  import {
    StepperTitle,
    useForwardProps,
    type StepperTitleProps,
  } from "reka-ui"
  import { computed, type HTMLAttributes } from "vue"

  const props = defineProps<
    StepperTitleProps & { class?: HTMLAttributes["class"] }
  >()

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
  })

  const forwarded = useForwardProps(delegatedProps)
</script>

<template>
  <StepperTitle
    v-bind="forwarded"
    :class="
      cn(
        'whitespace-nowrap text-sm font-normal text-secondary-700',
        props.class,
      )
    "
  >
    <slot />
  </StepperTitle>
</template>
